import React, { useState } from "react";

import { faChevronRight } from "@fortawesome/pro-regular-svg-icons";
import { twJoin } from "tailwind-merge";

import { AgentVersionStatus } from "src/agents/types";
import { StatusIcon } from "src/base-components/StatusIcon";
import { Icon } from "src/design-system/Icon";

export const AgentVersionName: React.FC<{
  name: string;
  status: AgentVersionStatus;
}> = ({ name, status }) => {
  return (
    <div className="flex items-center gap-1">
      <AgentVersionStatusIndicator status={status} />
      {name}
    </div>
  );
};

type AgentVersionNameExpandableProps = {
  name: string;
  description: string;
  status: AgentVersionStatus;
};

export const AgentVersionNameExpandable: React.FC<
  AgentVersionNameExpandableProps
> = ({ name, description, status }) => {
  const [expanded, setExpanded] = useState(false);

  const onClickExpand = () => setExpanded(!expanded);

  return (
    <div
      className={twJoin(
        "flex min-w-0 flex-col transition-[height]",
        expanded ? "h-auto" : "h-6",
      )}
    >
      <div className="flex items-center gap-1.5">
        <button
          className="p-1 transition-[transform]"
          data-loc="agent-version-expand"
          style={{ transform: expanded ? "rotate(90deg)" : "rotate(0deg)" }}
          onClick={(e) => {
            e.preventDefault();
            e.stopPropagation();
            onClickExpand();
          }}
        >
          <Icon variant="default" icon={faChevronRight} size="2xs" />
        </button>
        <AgentVersionStatusIndicator status={status} />
        <div className="truncate font-inter-semibold-13px text-gray-800">
          {name}
        </div>
      </div>
      <div
        key="description"
        className={twJoin(
          "mt-3 ml-3 translate-x-px overflow-hidden whitespace-pre-line border-gray-200 border-l pl-5 font-inter-normal-12px",
          !description && "text-gray-400",
        )}
      >
        {description || "No description"}
      </div>
    </div>
  );
};

export const AgentVersionStatusIndicator: React.FC<{
  status: AgentVersionStatus;
}> = ({ status }) => {
  return (
    <StatusIcon variant={status === "published" ? "published" : "draft"} />
  );
};
